import React, { createContext, useContext, useEffect } from 'react'
import { useFeatureFlag } from '@fs/zion-flags'
import { useStatusOverlay } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import useDynamicNavigation from './hooks/useDynamicNavigation'

const DynamicLinksContext = createContext('dynamicLinksContext')

export function useDynamicLinkContext() {
  return useContext(DynamicLinksContext)
}

function DynamicLinks({ children }) {
  const navigation = useDynamicNavigation()
  const showStatusOverlay = useStatusOverlay()
  const { t } = useTranslation()

  useEffect(() => {
    if (navigation.error) {
      showStatusOverlay({
        message: t('footer.cookie-preferences-error-msg-refresh', 'Please try again in a moment or refresh the page.'),
        type: 'error',
      })
    }
  }, [navigation, showStatusOverlay, t])

  return <DynamicLinksContext.Provider value={navigation}>{children}</DynamicLinksContext.Provider>
}

const emptyState = {}
export default function DynamicLinksProvider({ children }) {
  const { isOn: dynamicLinksOn } = useFeatureFlag('home_footer_dynamicLinks')

  if (dynamicLinksOn) {
    return <DynamicLinks>{children}</DynamicLinks>
  }
  return <DynamicLinksContext.Provider value={emptyState}>{children}</DynamicLinksContext.Provider>
}
